// generic dataset presentation page
// receives a json props with all info to build the page
import { data } from 'jquery';
import React from 'react';
import {Link} from 'react-router-dom';
import EpflLoader from '../helper/EpflLoader';
import StaticTable from '../helper/StaticTable';

class ChallengeSoftwareInfo extends React.Component {
    constructor(props){
        super(props)
        // grab query
        this.name = new URLSearchParams(this.props.history.location.search).get('name');
        this.state = {  general:[],
                        usability:[],
                        runtime:[],
                        paticipation:[],
                        error:""};
        this.buildGeneralArray.bind(this)
        this.buildRuntimeArray.bind(this)
        this.buildUsabilityArray.bind(this)
    }

    componentDidMount(){
        // fetch data from server
        this.fetchJSON();
    }
      // fetch the json from server
    fetchJSON(){
        const data = new FormData();
        data.append('SoftwareName',this.name);
        fetch('/api/getSoftwareInfo',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
            response.json().then((r) => {
                    // remove entry from the general struct
                    // remove runtime entry
                    this.setState({ general:this.buildGeneralArray(r["general"]),
                                    usability:this.buildUsabilityArray(r["usability"]),
                                    runtime:this.buildRuntimeArray(r["runtime"]),
                                    participation:r["participation"],
                                    error:r["error"]})
            })
            }
        })
        
    }

    buildGeneralArray(obj){
        let keys = Object.keys(obj).filter(k => k === "team" || k === "abstract" || k === "keyword")
        var output = [keys]
        output.push(keys.map(k => obj[k]))
        return output
    }

    buildUsabilityArray(obj){
        var keys = Object.keys(obj).slice(2,16)
        var output = [keys]
        output.push(keys.map(k => obj[k]))
        return output
    }

    buildRuntimeArray(obj){
        var keys = Object.keys(obj)
        let headers = [keys.shift()]
        headers.push(keys.shift())
        let data = [obj[headers[0]],obj[headers[1]]]

        // check if dataset# entry is "no"
        for (var i = 0; i < keys.length; i=i+3){
            if (obj[keys[i]] !== "no") {
                headers.push(obj[keys[i]])
                data.push(obj[keys[i+1]] + ", " + obj[keys[i+2]] + " (s)")
            }
            else 
                break
        }
        var output = [headers]
        output.push(data)
        return output
    }

    render () {
        if (this.state.error.length > 0)
            return (
                <div>
                    <h3>The requested software was not part of the challenge.</h3>
                    <h4>Return to the <Link to="/Challenge"> leaderboard page</Link>?</h4>
                </div>
            )
        else
            return (
                <div>
                    <h1>Report of {this.name}</h1>
                    {this.state.general.length === 0 ?
                    <EpflLoader/>
                    :
                    <div>
                        <div style={{display:"flex"}}>
                            <span style={{maxWidth:"1200px"}}>
                                <StaticTable data={this.state["general"]} vertical={true} tableName={"General"}/>
                            </span>
                            <div style={{minWidth:"50px"}}></div>
                            <span>
                                <h2>Participation</h2>
                                <hr></hr>
                                <ul className="list-bullet">
                                {this.state.participation.map(p =>
                                    <li>
                                        <Link to={"/ChallengeSoftwareResults?software="+this.name+"&modality="+p}>{p}</Link>
                                    </li>
                                    )}
                                </ul>
                            </span>
                        </div>
                        <br></br>
                        <div style ={{display:"flex"}}>
                            <span >
                                <StaticTable data={this.state["runtime"]} vertical={true} tableName={"Runtime"}/>
                            </span>
                            <span style={{minWidth:"50px"}}></span>
                            <span>
                                <StaticTable data={this.state["usability"]} vertical={true} tableName={"Usability"}/>
                            </span>
                        </div>
                    </div>
                    }
                </div>
            )
    }
}

export default ChallengeSoftwareInfo;